var _excluded = ["children"],
  _excluded2 = ["children", "menuAnchor", "menuWidth", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
import { BaseStyledWrapper, DROPDOWN_CHOICE_LIST_ATTR, DROPDOWN_MENU_DEFAULTS } from "./shared.js";
var StyledFooterActions = styled.div.withConfig({
  componentId: "CL__sc-1qbw3tr-0"
})(["display:flex;gap:var(--spacing-1);justify-content:flex-end;border-top:1px solid var(--border-color-dim);"]);
var StyledWrapper = styled(BaseStyledWrapper).withConfig({
  componentId: "CL__sc-1qbw3tr-1"
})(["padding:", ";min-width:max-content;display:flex;flex-direction:column;gap:", ";", "{padding-top:", ";}"], _ref => {
  var {
    $size
  } = _ref;
  return $size === 'large' ? 'var(--spacing-3)' : 'var(--spacing-2)';
}, _ref2 => {
  var {
    $size
  } = _ref2;
  return $size === 'large' ? 'var(--spacing-4)' : 'var(--spacing-3)';
}, StyledFooterActions, _ref3 => {
  var {
    $size
  } = _ref3;
  return $size === 'large' ? 'var(--spacing-3)' : 'var(--spacing-2)';
});
var FooterActions = _ref4 => {
  var {
      children
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/React.createElement(StyledFooterActions, _extends({
    role: "group",
    "aria-label": "Actions"
  }, props), children);
};
var DropdownMenuChoiceList = _ref5 => {
  var {
      children,
      menuAnchor = DROPDOWN_MENU_DEFAULTS.menuAnchor,
      menuWidth = DROPDOWN_MENU_DEFAULTS.menuWidth,
      size = DROPDOWN_MENU_DEFAULTS.size
    } = _ref5,
    props = _objectWithoutProperties(_ref5, _excluded2);
  return /*#__PURE__*/React.createElement(StyledWrapper, _extends({}, props, {
    $menuAnchor: menuAnchor,
    $menuWidth: menuWidth,
    $size: size,
    "aria-labelledby": props['aria-labelledby'],
    role: "group",
    [DROPDOWN_CHOICE_LIST_ATTR]: true
  }), children);
};

// Attach subcomponent
DropdownMenuChoiceList.FooterActions = FooterActions;
export default DropdownMenuChoiceList;